import { BookOpen, X, Plus } from "lucide-react";

export function CourseRow({ enrollment, busyId, onUnassign }) {
  const { course, status, progress, id } = enrollment;
  const canUnassign = progress === 0;
  return (
    <div className="border border-[var(--border)] p-4 hover:border-[var(--cyan)] transition-colors" data-testid={`sd-course-${course?.code}`} key={id}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <BookOpen size={16} strokeWidth={1.5} color="var(--cyan)" className="mt-0.5" />
          <div>
            <div className="font-mono text-xs text-[var(--cyan)]">{course?.code}</div>
            <div className="font-display font-bold uppercase">{course?.title}</div>
            <div className="font-mono text-[10px] text-[var(--text-2)] tracking-widest uppercase mt-0.5">
              {course?.stage} &middot; {course?.duration_hours}h
            </div>
          </div>
        </div>
        <div className="text-right shrink-0">
          <span className={`tag ${status === "completed" ? "tag-green" : "tag-cyan"}`}>{status}</span>
          {canUnassign && (
            <button
              onClick={() => onUnassign(course)}
              disabled={busyId === course?.id}
              className="ml-2 text-[var(--red)] hover:text-white"
              title="Unassign"
              data-testid={`sd-unassign-${course?.code}`}
            >
              <X size={14} />
            </button>
          )}
        </div>
      </div>
      <div className="mt-3 flex items-center gap-3">
        <div className="progress-track flex-1">
          <div className="progress-fill" style={{ width: `${progress}%` }} />
        </div>
        <div className="font-mono text-sm w-10 text-right">{progress}%</div>
      </div>
    </div>
  );
}

export function AssignPanel({ assignable, busyId, onAssign }) {
  return (
    <div className="mb-5 border border-[var(--cyan)] p-4" data-testid="sd-assign-panel">
      <div className="overline mb-3">// SELECT_COURSE_TO_ASSIGN</div>
      {assignable.length === 0 && (
        <div className="text-sm text-[var(--text-2)]">No additional courses available for this track.</div>
      )}
      <div className="grid sm:grid-cols-2 gap-2 max-h-72 overflow-auto">
        {assignable.map((c) => (
          <button
            key={c.id}
            disabled={busyId === c.id}
            onClick={() => onAssign(c)}
            className="text-left border border-[var(--border)] hover:border-[var(--cyan)] p-3 flex items-start justify-between gap-2 transition-colors"
            data-testid={`sd-assign-${c.code}`}
          >
            <div>
              <div className="font-mono text-[10px] text-[var(--cyan)]">{c.code}</div>
              <div className="font-display text-sm uppercase">{c.title}</div>
              <div className="font-mono text-[10px] text-[var(--text-2)] uppercase tracking-widest mt-1">
                {c.stage} &middot; {c.duration_hours}h
              </div>
            </div>
            <Plus size={14} color="var(--cyan)" />
          </button>
        ))}
      </div>
    </div>
  );
}
